import React, { useCallback, useContext, useState } from 'react'
import OfferPageStateTrackingContext from 'contexts/OfferPage/offerPageStateTrackingContext'
import CharterFlightOfferAirportOptionsList from './CharterFlightOfferAirportOptionsList'
import Modal from 'LuxKit/Modal/Modal'
import useModalElementContext from 'hooks/Modal/useModalElementContext'
import { airportLocationToAirport } from 'lib/flights/flightUtils'
import useOfferPageDispatch from 'hooks/OfferPage/useOfferPageDispatch'
import { OfferPageActions } from 'contexts/OfferPage/offerPageStateReducer'

interface Props {
  initialSelectedAirport?: App.Airport
  charterBundleRoute: App.CharterBundleRoute
}

function CharterFlightOfferAirportModal({ charterBundleRoute, initialSelectedAirport }: Props) {
  const { trackEvent } = useContext(OfferPageStateTrackingContext)
  const dispatch = useOfferPageDispatch()

  const [selectedAirport, setSelectedAirport] = useState(initialSelectedAirport)

  const modalElement = useModalElementContext()

  const closeFilter = useCallback(() => {
    modalElement.resolve()
    trackEvent('AIRPORT_FILTER_CLOSED')
  }, [modalElement, trackEvent])

  const onAirportSelect = useCallback((airport: App.AirportLocation) => {
    setSelectedAirport(airportLocationToAirport(airport))
  }, [])

  const onConfirm = useCallback(() => {
    dispatch({
      type: OfferPageActions.setAirport,
      airport: selectedAirport,
    })
    dispatch({
      type: OfferPageActions.setFlights,
      flights: true,
    })
    trackEvent('AIRPORT_FILTER_SELECTED')
    closeFilter()
  }, [closeFilter, dispatch, selectedAirport, trackEvent])

  return (
    <Modal
      title="Where will you depart from?"
      subtitle="Select your preferred airport"
      onClose={closeFilter}
      onPrimaryActionClick={onConfirm}
      primaryActionText="Continue"
      height="full"
      tabletHeight="auto"
    >
      <CharterFlightOfferAirportOptionsList
        selectedAirport={selectedAirport}
        onSelectAirport={onAirportSelect}
        charterBundleRoute={charterBundleRoute}
        withRadioButtons
      />
    </Modal>
  )
}

export default CharterFlightOfferAirportModal
